const dietData = [
  {
    name: '全部类型',
    curMeal: -1,
    p_type: 0,
    type2: -1
  },
  {
    name: '饮食打卡',
    curMeal: -1,
    p_type: 3,
    type2: -1
  },
  {
    name: '全餐打卡',
    curMeal: -1,
    p_type: 6,
    type2: -1
  },
  {
    name: '体测打卡',
    curMeal: -1,
    p_type: 2,
    type2: -1
  },
  {
    name: '观察期打卡',
    curMeal: -1,
    p_type: 7,
    type2: -1
  },
  {
    name: '运动打卡',
    curMeal: -1,
    p_type: 4,
    type2: -1
  },
  {
    name: '习惯挑战',
    curMeal: -1,
    p_type: 5,
    type2: -1
  }
]
const reviewData = [
  {
    name: '开头语',
    val: 'opening_words',
    value: '',
    change: true,
    minlength: 10,
    maxlength: 1000
  },
  {
    name: '主食',
    val: 'staple_comment',
    value: '',
    minlength: 10,
    maxlength: 1000
  },
  {
    name: '蛋白质',
    val: 'protein_comment',
    value: '',
    minlength: 10,
    maxlength: 1000
  },
  {
    name: '蔬菜',
    val: 'vegetable_comment',
    value: '',
    minlength: 10,
    maxlength: 1000
  },
  {
    name: '油脂',
    val: 'grease_comment',
    value: '',
    minlength: 10,
    maxlength: 1000
  }
  /* {
    name: '结束语',
    val: 'end_words',
    value: '',
    minlength: 10,
    maxlength: 1000,
  } */
]
const observeReviewData = [
  {
    name: '开头语',
    val: 'opening_words',
    value: '',
    change: true,
    minlength: 10,
    maxlength: 1000,
    replace: true
  },
  {
    name: '主食',
    val: 'staple_comment',
    value: '',
    minlength: 10,
    maxlength: 1000
  },
  {
    name: '蛋白质',
    val: 'protein_comment',
    value: '',
    minlength: 10,
    maxlength: 1000
  },
  {
    name: '蔬菜',
    val: 'vegetable_comment',
    value: '',
    minlength: 10,
    maxlength: 1000
  },
  {
    name: '油脂',
    val: 'grease_comment',
    value: '',
    minlength: 10,
    maxlength: 1000
  },
  {
    name: '饮食搭配',
    val: 'taste_comment',
    value: '',
    minlength: 10,
    maxlength: 1000
  }
  /* {
    name: '结束语',
    val: 'end_words',
    value: '',
    minlength: 10,
    maxlength: 1000,
    replace: true
  } */
]
const formatTime = function (datetime) {
  var year = datetime.getFullYear()
  var month = datetime.getMonth() + 1
  var date = datetime.getDate()
  var hour = datetime.getHours()
  if (hour <= 9) {
    hour = '0' + hour
  }
  var minute = datetime.getMinutes()
  if (minute <= 9) {
    minute = '0' + minute
  }
  var second = datetime.getSeconds()
  if (second <= 9) {
    second = '0' + second
  }
  return year + '-' + month + '-' + date //+"."+mseconds;
}
const coachReview = {
  //实时保存
  set(id, data) {
    localStorage.setItem('saveNotCampReviewById_' + id, JSON.stringify(data))
  },
  //获取缓存
  get(id) {
    return localStorage.getItem('saveNotCampReviewById_' + id)
  },
  remove(id) {
    localStorage.removeItem('saveNotCampReviewById_' + id)
  }
}
const deepClone = function (obj) {
  //可传入对象 或 数组
  //  判断是否为 null 或 undefined 直接返回该值即可,
  if (obj === null || !obj) return obj
  // 判断 是要深拷贝 对象 还是 数组
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    //对象字符串化的值会为 "[object Object]"
    let target = {} //生成新的一个对象
    const keys = Object.keys(obj) //取出对象所有的key属性 返回数组 keys = [ ]
    //遍历复制值, 可用 for 循环代替性能较好
    keys.forEach((key) => {
      if (obj[key] && typeof obj[key] === 'object')
        //如果遇到的值又是 引用类型的 [ ] {} ,得继续深拷贝
        target[key] = deepClone(obj[key])
      //递归
      else target[key] = obj[key]
    })
    return target //返回新的对象
  } else if (Array.isArray(obj)) {
    // 数组同理
    let arr = []
    obj.forEach((item, index) => {
      if (item && typeof item === 'object') arr[index] = deepClone(item)
      else arr[index] = item
    })
    return arr
  }
}
export {
  dietData,
  formatTime,
  observeReviewData,
  reviewData,
  coachReview,
  deepClone
}
